
import { FunctionService } from './../../../services/general/function.service';
import { UserManageService } from './../../../services/user/user-manage.service';
import { StripeCheckoutService } from 'src/app/services/payment/stripe/stripe-checkout.service';
import { StripeSetupService } from 'src/app/services/payment/stripe/stripe-setup.service';
import { TranslateService } from '@ngx-translate/core';
import { StripeSessionService } from 'src/app/services/payment/stripe/stripe-session.service';
import { LinkService } from 'src/app/services/general/link.service';
import { PlatformType } from 'src/app/types/device';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params, NavigationExtras } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { StripeCheckoutSessionStatus, StripeCheckoutSessionPaymentStatus, TransactionType } from 'src/app/types/transaction';
import { Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { UserStripeCheckoutSession, User } from 'src/app/interfaces/user';
import { PopupService } from 'src/app/services/general/popup.service';
import { CountdownComponent } from 'ngx-countdown';
import { Price, ProductAccountPageParam } from 'src/app/interfaces/product';

import { CheckoutParam } from 'src/app/interfaces/stripe';
import { StripeMetaService } from 'src/app/services/payment/stripe/stripe-meta.service';
import { BlastPackageService } from 'src/app/services/blast/blast-package.service';
import { SmsPaymentService } from 'src/app/services/sms/sms-payment.service';

@Component({
  selector: 'app-stripe-status',
  templateUrl: './stripe-status.page.html',
  styleUrls: ['./stripe-status.page.scss'],
})
export class StripeStatusPage implements OnInit, OnDestroy {

  @ViewChild('cd', { static: false }) private countdown: CountdownComponent;
  /**
   * Count down config
   */
  countdownConfig: any;

  cancelCheckout: boolean;
  sessionId: string;
  platformType: PlatformType;
  currency: string;
  private debugMode: boolean;

  sessionStatus: StripeCheckoutSessionStatus;
  paymentStatus: StripeCheckoutSessionPaymentStatus;
  transactionType: TransactionType;
  sessionUid: string;

  customerId: string;
  showAppBtn: boolean;

  session: any;
  checkoutParam: CheckoutParam;
  time: any;

  private userSubscription: Subscription;

  private productAccountPageParam: ProductAccountPageParam;
  private creditIdList: string[];

  private blastCreditIdList: string[];
  // private blastUsageId: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private platform: Platform,
    private translate: TranslateService,
    private stripeSetupService: StripeSetupService,
    private stripeSessionService: StripeSessionService,
    private stripeCheckoutService: StripeCheckoutService,
    private stripeMetaService: StripeMetaService,
    private userService: UserService,
    private userManageService: UserManageService,
    private functionService: FunctionService,
    private linkService: LinkService,
    private popupService: PopupService,
  ) { }

  ngOnInit() {
    this.watchRoute();
  }

  ngOnDestroy(): void {
      this.unwatchUser();
  }

  ionViewWillEnter() {
    
  }

  ionViewWillLeave() {
    this.unwatchUser();
  }

  watchRoute() {
    this.route.params.subscribe((param: Params) => {
      const route = this.router.getCurrentNavigation();
      const state = route?.extras?.state;

      if (state?.sessionId) {
        this.sessionId = state.sessionId;
      } else if (param?.sessionId) {
        this.sessionId = param.sessionId;
      }

      if (state?.sessionStatus) {
        this.sessionStatus = state.sessionStatus;
      } else if (param?.sessionStatus) {
        this.sessionStatus = param.sessionStatus;
      }

      if (state?.paymentStatus) {
        this.paymentStatus = state.paymentStatus;
      } else if (param?.paymentStatus) {
        this.paymentStatus = param.paymentStatus;
      }

      if (state?.transactionType) {
        this.transactionType = state.transactionType;
      } else if (param?.transactionType) {
        this.transactionType = param.transactionType;
      }

      if (state?.currency) {
        this.currency = state.currency;
      } else if (param?.currency) {
        this.currency = param.currency;
      }

      if (state?.debugMode === true || state?.debugMode === 'true') {
        this.debugMode = true;
      } else if (param?.debugMode === true || param?.debugMode === 'true') {
        this.debugMode = true;
      } else {
        this.debugMode = false;
      }

      if (state?.platformType) {
        this.platformType = state.platformType;
      } else if (param?.platformType) {
        this.platformType = param.platformType;
      }

      if (state?.sessionUid) {
        this.sessionUid = state.sessionUid;
      } else if (param?.sessionUid) {
        this.sessionUid = param.sessionUid;
      } else {
        this.sessionUid = '';
      }

      if (state?.customerId) {
        this.customerId = state.customerId;
      } else if (param?.customerId) {
        this.customerId = param.customerId;
      } else {
        this.customerId = '';
      }

      if (state?.creditIdList?.length) {
        this.creditIdList = state.creditIdList;
      } else if (param?.creditIdList?.length) {
        this.creditIdList = param.creditIdList;
      } else {
        this.creditIdList = [];
      }

      if (state?.blastCreditIdList?.length) {
        this.blastCreditIdList = state.blastCreditIdList;
      } else if (param?.blastCreditIdList?.length) {
        this.blastCreditIdList = param.blastCreditIdList;
      } else {
        this.blastCreditIdList = [];
      }

      // if (state?.blastUsageId) {
      //   this.blastUsageId = state.blastUsageId;
      // } else if (param?.blastUsageId) {
      //   this.blastUsageId = param.blastUsageId;
      // }

      if (state?.productAccountPageParam) {
        this.productAccountPageParam = state.productAccountPageParam;
      } else if (param?.productAccountPageParam) {
        this.productAccountPageParam = param.productAccountPageParam;
      }

      if (state?.time) {
        this.time = state.time;
      } else if (param?.time) {
        this.time = param.time;
      }

      if (state?.cancelCheckout === true || state?.cancelCheckout === 'true') {
        this.cancelCheckout = true;
      } else if (param?.cancelCheckout === true || param?.cancelCheckout === 'true') {
        this.cancelCheckout = true;
      } else {
        this.cancelCheckout = false;
      }

      if (this.sessionId && this.currency) {
        if (this.platform.is('hybrid')) {
          this.watchUser();
        } else {
          this.checkOpenAppBtn();
          this.retreiveSession();
        }
      } else {
        this.promptInvalid();
      }
    });
  }

  async watchUser() {
    if (!this.userSubscription) {
      this.userSubscription = this.userService.observableUser.subscribe((user: User) => {
        if (user?.stripeSession?.sessionId) {
          this.setupStripeSession(user.stripeSession);
        } else if (user?.uid) {
          
        }
      });
    }
  }

  async unwatchUser() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
      this.userSubscription = null;
    }
  }

  setupStripeSession(stripeSession: UserStripeCheckoutSession) {
    if (stripeSession?.sessionId) {
      this.sessionId = stripeSession.sessionId;
    }
    if (stripeSession?.sessionStatus) {
      this.sessionStatus = stripeSession.sessionStatus;
    }
    if (stripeSession?.paymentStatus) {
      this.paymentStatus = stripeSession.paymentStatus;
    }
    if (stripeSession?.checkoutParam?.transactionType) {
      this.transactionType = stripeSession.checkoutParam.transactionType;
    }
    if (stripeSession?.checkoutParam?.debugMode === true) {
      this.debugMode = stripeSession.checkoutParam.debugMode;
    } else {
      this.debugMode = false;
    }
    if (stripeSession?.currency) {
      this.currency = stripeSession.currency;
    }
    if (stripeSession?.checkoutParam?.platform) {
      this.platformType = stripeSession.checkoutParam.platform;
    }
    if (stripeSession?.uid) {
      this.sessionUid = stripeSession.uid;
    }
    
    if (stripeSession?.creditIdList?.length) {
      this.creditIdList = stripeSession.creditIdList;
    }

    if (stripeSession?.blastCreditIdList?.length) {
      this.blastCreditIdList = stripeSession.blastCreditIdList;
    }
    // if (stripeSession?.blastUsageId) {
    //   this.blastUsageId = stripeSession.blastUsageId;
    // }
    // if (stripeSession?.blastUnpaidIdList?.length) {
    //   this.blastUnpaidIdList = stripeSession.blastUnpaidIdList;
    // }

    if (stripeSession?.productAccountPageParam) {
      this.productAccountPageParam = stripeSession.productAccountPageParam;
    }
    if (stripeSession?.time) {
      this.time = stripeSession.time;
    }

    this.retreiveSession();
  }

  async retreiveSession() {
    if (this.currency && this.sessionId) {
      this.session = await this.stripeSessionService.retrieveSessionCall(this.debugMode, this.currency, this.sessionId);
      if (!this.customerId) {
        if (this.session?.customer) {
          this.customerId = this.session.customer;
        } else if (this.session?.customerId) {
          this.customerId = this.session.customerId;
        }
      }
      this.checkoutParam = await this.stripeMetaService.stripeRetrieveCheckoutParamCall(this.debugMode, this.currency, this.sessionId, this.customerId);
      if (this.session?.id && this.checkoutParam) {
        if (this.session?.payment_status) {
          this.paymentStatus = this.session.payment_status;
        }
        if (this.session?.status) {
          this.sessionStatus = this.session.status;
        }
        if (this.checkoutParam?.uid) {
          this.sessionUid = this.checkoutParam.uid;
        }
        if (this.checkoutParam?.platform) {
          this.platformType = this.checkoutParam.platform;
        }
        if (this.checkoutParam?.transactionType) {
          this.transactionType = this.checkoutParam.transactionType;
        }
      }
      this.checkSession();
    }
  }

  checkSession() {
    if (this.sessionId && this.paymentStatus && this.sessionStatus) {
      if (this.sessionStatus === 'complete') {
        if (this.paymentStatus) {
          if (this.paymentStatus === 'paid') {
            if (this.transactionType === 'account' && !this.creditIdList?.length) {
              this.checkUser();
            } else if (this.transactionType === 'blast' && !this.blastCreditIdList?.length) {
              this.checkUser();
            } else {
              if (!this.showAppBtn || (this.sessionUid && this.sessionUid === this.userService.uid)) {
                this.setupCountdownConfig();
                this.updateUserStripeResultPage(true);
              }
            }
          } else {
            this.updateUserStripeResultPage(true);
          }
        }
      } else {
        this.checkUser();
      }
    } else {
      this.promptInvalid();
    }
  }

  checkUser() {
    if (this.sessionUid && this.userService.uid === this.sessionUid) {
      if (!this.userSubscription) {
        this.watchUser();
      }
    }
  }

  checkBackBtn() {
    if (this.userService?.uid && this.sessionUid === this.userService.uid && this.transactionType &&
      (this.sessionStatus === 'complete' || this.cancelCheckout) && this.paymentStatus && this.paymentStatus !== 'paid') {
      return true;
    } else if (this.time?.seconds) {
      const now = this.functionService.firestoreLocalTime;
      if ((this.time.seconds - now.seconds) > 3600) {
        return true;
      }
    } else if (!this.time && this.session) {
      return true;
    }
    return false;
  }

  goBack() {
    this.updateUserStripeResultPage(true);
    if (this.transactionType === 'account') {
      this.goAccountPage();
    } else if (this.transactionType === 'blast') {
      this.goBlastPackagePage();
    } else {
      this.goMainPage();
    }
  }

  checkOpenAppBtn() {
    if (this.platformType && this.platformType !== 'web' && this.platformType !== 'pwa') {
      if (!this.platform.is('hybrid') && (this.platform.is('ios') || this.platform.is('android'))) {
        this.showAppBtn = true;
      }
    }
  }

  async retry() {
    if (this.sessionId && this.transactionType && this.session) {
      const stripe = this.stripeSetupService.setupStripe(this.currency, this.debugMode);
      if (stripe) {
        const total: Price = {
          currency: this.session?.currency?.toUpperCase(),
          amount: this.session?.amount_total ? Number(this.session.amount_total) : 0
        };
        if (this.checkoutParam?.transactionType) {
          this.stripeCheckoutService.redirectToCheckout(
            stripe,
            this.sessionId,
            total,
            this.productAccountPageParam,
            this.checkoutParam?.transactionType,
            this.checkoutParam,
          );
        } else {
          // error
          this.goBack();
        }
      }
    } else {
      this.goBack();
    }
  }

  setupCountdownConfig() {
    if (!this.countdownConfig?.leftTime) {
      this.countdownConfig = {
        leftTime: 6,
        format: 's'
      };
    }
  }

  /**
   * Stop count down
   */
   stopCountdown() {
    if (this.countdown) {
      this.countdown.stop();
      this.countdownConfig = null;
    }
  }

  /**
   * Handle event
   * @param event Event
   */
  handleEvent(event: any) {
    if (event?.action === 'done') {
      this.stopCountdown();
      this.goResultPage();
    }
  }

  async promptInvalid() {
    const alert = await this.popupService.presentAlert(
      this.translate.instant('STRIPE.status.msg.invalid')
    );
    alert.onWillDismiss().then(() => {
      this.goMainPage();
    });
  }

  backApp() {
    this.linkService.openUrl('https://wedding.thebigdays.com/#/payment/stripe-status', true);
  }

  goResultPage() {
    if (this.transactionType === 'account') {
      this.goAccountPaymentResultPage(
        this.creditIdList?.length ? this.creditIdList[0] : this.userService?.user?.stripeSession?.creditIdList?.[0],
        this.checkoutParam?.upgrade ? true : false,
        this.checkoutParam?.trial ? true : false,
        this.checkoutParam?.debugMode ? true : false,
        this.checkoutParam?.accountId ? this.checkoutParam.accountId : '',
      );
    } else if (this.transactionType === 'blast') {
      this.goBlastResultPage();
    } else {
      this.goMainPage();
    }
  }

  goAccountPaymentResultPage(creditId?: string, upgradeMode?: boolean, upgradeTrial?: boolean, debugMode?: boolean, accountId?: string) {
    const navigationExtras: NavigationExtras = {
      replaceUrl: true,
      state: {
        result: 'success',
        checkout: true,
        uid: this.sessionUid,
        creditId,
        upgradeMode,
        upgradeTrial,
        debugMode,
        accountId,
      }
    };
    this.router.navigate(['/subscription/payment-result'], navigationExtras);
  }

  goBlastResultPage() {
    const navigationExtras: NavigationExtras = {
      replaceUrl: true,
      state: {
        blastCreditIdList: this.blastCreditIdList?.length ? this.blastCreditIdList : this.userService?.user?.stripeSession?.blastCreditIdList,
      }
    };
    this.router.navigate(['/blast/result'], navigationExtras);
  }

  goAccountPage() {
    const navigationExtras: NavigationExtras = {
      replaceUrl: true,
      state: {
        total: this.session?.amount_total,
        accountId: this.checkoutParam?.accountId,
        currency: this.session?.currency,
        itemList: this.checkoutParam?.itemList,
        referralCode: this.checkoutParam?.referralCode,
        voucherId: this.checkoutParam?.voucherId,
        giftMode: this.checkoutParam?.gift ? true : false,
        bulkMode: this.checkoutParam?.bulk ? true : false,
        upgradeTrial: this.checkoutParam?.trial ? true : false,
        upgradeMode: this.checkoutParam?.upgrade ? true : false,
      }
    };
    this.router.navigate(['/subscription/account'], navigationExtras);
  }

  goBlastPackagePage() {
    this.router.navigate(['/blast/package'], { replaceUrl: true });
  }

  goMainPage() {
    this.linkService.goMainPage();
  }

  async updateUserStripeResultPage(resultPage: boolean) {
    if (resultPage && this.userService?.user?.stripeSession) {
      this.userManageService.updateUser(
        { stripeSession: this.functionService.firestoreDeleteField }
      );
    }
  }

  async getTransactionListByUidCall() {
    // await this.popupService.presentLoading();
    // await this.smsPaymentService.getTransactionListByUidCall();
    // this.popupService.dismissLoading();
  }

}
